module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLightItalic-BETA.29e85e0f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ExtraLightItalic-BETA.woff2
// module id = 690
// module chunks = 21